<template>
	<div class="wrapper" :style="position">

		<!-- Slot -->
		<div id="animator" :class="{shake, flash, bounce}" :style="fixedSize">
			<div class="card" ref="card" :class="{ type: type, button: isButton, 'button-engaged': buttonEngaged }" :style="outerCss" @click="onClick">

				<!-- Empty / Regular text-->
				<div v-if="!placedCardValue">
					<span class="capitalize main-text" v-if="(text || format) && !slotId" :class="{ 'largeText': big }" v-html="getText()"></span>
					<h2 v-else style="opacity: 0.2;">?</h2>

					<div v-if="isButton && buttonEngaged" class="pgc-wrapper">
						<hr class="separator">
						<span class="pgc-value">{{ pgc }}</span>
						<span class="pgc-unit">{{ $t('unit_pgc_year') }}</span>
					</div>
				</div>

				<!-- Placed image -->
				<img v-else-if="image" :src='getImage(imagePath)' class="pointer-events-none">

				<!-- Placed card text -->
				<div v-else class="card-body" :style="innerCss">
					<h6 class="card-text" v-html="autoText(remap ? 'formula' : 'title')"></h6>
				</div>
			</div>
		</div>
	</div>
</template>



<script>
// import Component from '@/components/Component.vue';

export default {
	props: [ "type", "autoId", "slotId", "x", "y", "anchor", "slotWidth", "slotHeight", "image", "remap", "mapping", "text", "format", "big", "color", "isButton", "pgc" ],
	components: {},
	data() {
		return {
			show: true,
			empty: true,
			placedCardValue: null,
			imagePath: null,
			shake: false,
			shakeTimeout: null,
			flash: false,
			flashTimeout: null,
			bounce: false,
			bounceTimeout: null,
			widthRatio: 1,
			heightRatio: 1,

			buttonEngaged: false,
		};
	},
	methods: {
		getImage(path) {
			return require('@/assets/' + path);
		},
		getText() {
			let text = this.text || '';
			let format = this.format || '{}';
			return format.replace('{}', this.$t(text));
		},
		autoText(key) {
			if (this.placedCardValue) {
				let text = this.$t(`card_${this.placedCardValue}_title`);
				if (this.$te(`card_${this.placedCardValue}_${key}`)) {
					text = this.$t(`card_${this.placedCardValue}_${key}`);
				}

				if (this.remap && this.mapping.text[this.placedCardValue]) {
					text = this.mapping.text[this.placedCardValue].replace('{}', text);
				}
				else {
					console.log("shit", text);
				}

				return text;
			}
		},
		place(card) {
			this.placedCardValue = card;
			this.imagePath = this.mapping.image[this.placedCardValue];
			this.playBounce();
		},
		clear() {
			this.placedCardValue = null;
		},
		clearAnimations() {
			this.shake = false;
			this.flash = false;
			this.bounce = false;
			clearTimeout(this.shakeTimeout);
			clearTimeout(this.flashTimeout);
			clearTimeout(this.bounceTimeout);
		},
		playShake() {
			this.clearAnimations();
			setTimeout(() => {
				this.shake = true;
				this.shakeTimeout = setTimeout(() => {
					this.shake = false;
				}, 800);
			}, 50);
		},
		playFlash() {
			this.clearAnimations();
			setTimeout(() => {
				this.flash = true;
				this.flashTimeout = setTimeout(() => {
					this.flash = false;
				}, 800);
			}, 50);
		},
		playBounce() {
			this.clearAnimations();
			setTimeout(() => {
				this.bounce = true;
				this.bounceTimeout = setTimeout(() => {
					this.bounce = false;
				}, 800);
			}, 50);
		},
		getSize(graphics) {
			if (this.$refs.card) {
				let rect = this.$refs.card.getBoundingClientRect();
				let w = rect.width * (graphics.width / graphics.rect.width) + 4;
				let h = rect.height * (graphics.height / graphics.rect.height) + 4;
				return  { w, h };
			}
			return { w: 10, h: 10 };
		},
		// labelEnter() {
			// this.$emit('labelEnter');
		// },
		// labelLeave() {
			// this.$emit('labelLeave');
		// },

		onClick() {
			this.buttonEngaged = !this.buttonEngaged;
			this.$log.onSlotToggle(this.autoId, this.buttonEngaged);
			this.$emit("click", this.autoId, this.buttonEngaged);
		},
	},
	computed: {
		position() {
			// return `left: calc(${this.x}*100%); top: calc(${this.y}*100%); transform: translate(-${this.anchor.x*100}%, -${this.anchor.y*100}%);`;
			return {
				left: `${this.x}%`,
				top: `${this.y}%`,
				width: `${this.slotWidth}%`,
				height: `${this.slotHeight}%`,
				transform: `translate(-50%, -50%)`,
			}
		},
		fixedSize() {
			let style = {};
			if (this.slotWidth) { style.width = "100%"; }
			if (this.slotHeight) { style.height = "100%"; }
			return style;
		},
		outerCss() {
			let style = {};

			if (this.slotWidth) { style.width = "100%"; }
			if (this.slotHeight) { style.height = "100%"; }
			style.color = this.color;

			// style.border = `1px dashed #00000055`;

			return style;
		},
		innerCss() {
			let style = {};
			style.backgroundColor = "transparent";
			return style;
		},

		rect() {
			return this.$refs.card.getBoundingClientRect();
		},
		width() {
			return this.rect.width * this.widthRatio;
			// return this.$refs.card.offsetWidth;
		},
		height() {
			return this.rect.height * this.heightRatio;
			// return this.$refs.card.offsetHeight;
		},
	}
};
</script>



<style scoped>
	.wrapper {
		position: absolute;
	}


	.card {
		/*border-radius: 0.4em;*/
		background: transparent;
		color: black;
		text-align: center;
		padding: 0.2em;
		user-select: none;
		/*box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.3);*/
		/*box-shadow: 0 1px 4px rgb(0 0 0 / 55%);*/
		border: none;
/*		border: 1px solid red;*/
		justify-content: space-around;
		line-height: 1.1rem;

		background-repeat: no-repeat;
		background-position: center;
		background-size: contain;

		transition: all .06s ease-in;
		/*filter: grayscale(100%) brightness(150%) sepia(50%) hue-rotate(50deg) saturate(300%);*/
		/*filter: grayscale(100%) brightness(1000%);*/
	}

	.card-body {
		/*padding: 0.8em 0.5em;*/
		/*border: 1px solid white;*/
		/*border-radius: calc(0.4em - 0.2em);*/
		border: none;
		/*box-shadow: 0 1px 4px rgb(0 0 0 / 55%);*/

		display: flex;
		flex-direction: column;
		justify-content: center;

		hyphens: auto;
		transition: all .06s ease-in;
	}

	.empty {
		background-color: #d9f1ff77;
		backdrop-filter: blur(5px);
		color: #333;
	}
	.empty .card-body {
		border: none;
	}

	.locked {
		backdrop-filter: blur(10px);
		color: #333;
	}
	.locked .card-body {
		border-color: rgba(0, 0, 0, 0.5);
	}

	/*.label {*/
		/*border: 1px solid #096b00;*/
		/*color: #096b00;*/
		/*backdrop-filter: blur(10px);*/
		/*transition: all 250ms ease;*/
	/*}*/
	/*.label .card-body {*/
		/*border: none;*/
		/*padding: 0.2em;*/
	/*}*/

	.largeText {
		font-size: 1.75em;
		opacity: 0.5;
	}

	.capitalize:first-letter {
		text-transform: uppercase;
	}


	.button {
		background-color: var(--bs-light);
		border: 1px solid currentColor;
		padding: 0.5em;
		opacity: 0.7;
	}
	.button-engaged {
		opacity: 1;
	}
	.button:hover {
		opacity: 1;
	}
	.button:active {
		transform: scale(0.95);
	}

	.button .main-text {
		font-weight: 500;
	}

	.pgc-wrapper {}
	.separator {
/*		opacity: 0.5;*/
		margin: .4em;
	}
	.pgc-value {
		font-size: 1.4em;
		font-weight: bold;
		margin-right: .3em;
	}
	.pgc-unit {
		font-size: .7em;
		line-height: 0;
	}


	.shake {
		animation: Shake .6s ease-out;
	}
	@keyframes Shake {
		0%	{ transform: translate(calc(2.0*10.0px)); filter: grayscale(100%) brightness(40%) sepia(100%) hue-rotate(-50deg) saturate(600%); } /* Red */
		10%	{ transform: translate(calc(2.0*-8.1px)); }
		20%	{ transform: translate(calc(2.0*6.4px)); }
		30%	{ transform: translate(calc(2.0*-4.9px)); }
		40%	{ transform: translate(calc(2.0*3.6px)); }
		50%	{ transform: translate(calc(2.0*-2.5px)); }
		60%	{ transform: translate(calc(2.0*1.6px)); }
		70%	{ transform: translate(calc(2.0*-0.9px)); }
		80%	{ transform: translate(calc(2.0*0.4px)); }
		90%	{ transform: translate(calc(2.0*-0.1px)); }
		100%{ transform: translate(calc(2.0*0.0px)); }
	}

	.flash {
		animation: Flash .6s ease;
	}
	@keyframes Flash {
		0%	{ transform: scale(1.10); filter: brightness(500%); }
		25%	{ transform: scale(0.95); }
		50%	{ transform: scale(1.02); filter: brightness(110%); }
		75%	{ transform: scale(0.99); }
		100%{ transform: scale(1.00); }
	}

	.bounce {
		animation: Bounce .6s ease-out;
	}
	@keyframes Bounce {
		0%	{ transform: scale(1.10); }
		25%	{ transform: scale(0.95); }
		50%	{ transform: scale(1.02); }
		75%	{ transform: scale(0.99); }
		100%{ transform: scale(1.00); }
	}
</style>
